import { ENDPOINT, HTTP_METHOD } from 'src/constants/api';
import { DTO } from './base.dto';
import { ResponseType } from 'axios';
import { IMDApplicationRequest } from '../interfaces/mortgage-deal/mortgage-application-list';

export class GetMortgageApplicationListDTO extends DTO {
	public param: undefined;
	public body: undefined;
	public url: string = ENDPOINT.GET_MORTGAGE_APPLICATION_LIST;
	public method: HTTP_METHOD = HTTP_METHOD.GET;
	public readonly responseType: ResponseType = 'json';
	constructor(public query: IMDApplicationRequest) {
		super();
		this.query = query;
	}
}
